export default __webpack_public_path__ + "static/media/intro-copy-1.640ed68d.png";